export default function hasToken(): string | null {
  return sessionStorage.getItem("token");
}
